__webpack_require__.p = "https://static.smartlink.intlgame.com/console/";